import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import PdpSharedDetailMeasurement from './helpers/PdpSharedDetailMeasurement';

// helpers
import get from 'lodash.get';

function PdpSharedDetailBust({ item }) {
    return (
        <PdpSharedDetailMeasurement
            dataTn="pdp-spec-bust"
            measurements={get(item, 'measurement.bust')}
        />
    );
}

PdpSharedDetailBust.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailBust, {
    item: graphql`
        fragment PdpSharedDetailBust_item on Item {
            measurement {
                bust: display(fields: [chest]) {
                    ...PdpSharedDetailMeasurement_measurements
                }
            }
        }
    `,
});
